<template>
  <layout>
    <rdkm-title>
      {{ $t('Сотрудники') }}
      <router-link tag="span" to="/users/add">
        <b-button class="float-right" right size="sm" variant="primary">
          <font-awesome-icon icon="plus" />{{ $t('Добавить') }}
        </b-button>
      </router-link>
    </rdkm-title>
    <div class="tile">
      <filter-form
        :name="filterQuery.name"
        :organizationId="filterQuery.organizationId"
        :email="filterQuery.email"
        :isDeleted="filterQuery.isDeleted"
        :isUser="filterQuery.isUser"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <rdkm-grid ref="grid" :state="filterQuery">
        <grid-column name="code" :title="$t('Код')" :url="editUrl" cell="edit-cell" width="180"></grid-column>
        <grid-column
          name="login"
          :title="$t('Логин')"
          width="180"
        ></grid-column>
        <grid-column name="name" :title="$t('ФИО')"></grid-column>
        <grid-column name="organization" :title="$t('Организация')"></grid-column>
        <grid-column name="post" :title="$t('Должность')"></grid-column>
        <grid-column name="email" :title="$t('E-Mail')"></grid-column>
        <grid-column name="phone" :title="$t('Телефон')" :format="function(phone) { return formatPhone(phone); }"></grid-column>
        <grid-column name="additionalPhone" :title="$t('Телефон (внеурочный)')" :format="function(phone) { return formatPhone(phone); }"></grid-column>
        <grid-column name="note" :title="$t('Примечание')"></grid-column>
        <grid-column name="DELETE" cell="delete-cell"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import PhoneFormatter from "../../helpers/phone.formatter";
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';

export default {
  name: 'Users',
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
  data() {
    return { filterQuery: {} };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
    this.filterQuery.organizationId = this.organizationId;
  },
  computed: {
    organizationId() {
      return this.filterQuery.organizationId ? this.filterQuery.organizationId  : this.$auth.user().impersonateOrganizationId || this.$auth.user().organizationId;
    },
  },
  methods: {
    formatPhone(phone) {
      return PhoneFormatter.format(phone);
    },
    editUrl(e) {
      return '/users/' + e.id + (e.isImpersonate ? '/' + this.organizationId : '');
    }
  }
};
</script>
